import { ContestTemplateDetailsModule } from '@/modules/fantasy/contest-template/details';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/fantasy/contest-template/details'
)({
  validateSearch: searchSchema,
  component: ContestTemplateDetailsPage,
});

function ContestTemplateDetailsPage() {
  return <ContestTemplateDetailsModule />;
}
